import { initializeApp } from 'firebase/app';
import { getRemoteConfig } from 'firebase/remote-config';

const ONE_MINUTE = 60000;
const ONE_HOUR = ONE_MINUTE * 60;

const appIdDev = '1:124390173883:web:8a1eedbbdf46096109cd9e';
const appIdAcc = '1:124390173883:web:49cdd42227e8657f09cd9e';
const appIdProd = '1:124390173883:web:bb6ec861821dc4c409cd9e';

const getAppId = (environment: string) => {
  if (environment === 'acc') return appIdAcc;
  if (environment === 'dev') return appIdDev;
  if (environment === 'prod') return appIdProd;
  return appIdDev;
};

export function getRemoteConfigByEnvironment(environment: string) {
  const firebaseConfig = {
    apiKey: 'AIzaSyB-p0JgAORsLf4iZNt-jvqZfozToxrQiuI',
    authDomain: 'customer-extranet-wal.firebaseapp.com',
    projectId: 'customer-extranet-wal',
    storageBucket: 'customer-extranet-wal.firebasestorage.app',
    messagingSenderId: '124390173883',
    appId: getAppId(environment),
  };

  const app = initializeApp(firebaseConfig);
  const remoteConfig = getRemoteConfig(app);

  remoteConfig.settings = {
    minimumFetchIntervalMillis: ONE_HOUR,
    fetchTimeoutMillis: ONE_MINUTE,
  };

  return remoteConfig;
}
